import { render, staticRenderFns } from "./MyDonatePage.vue?vue&type=template&id=150cb3cb&"
import script from "./MyDonatePage.vue?vue&type=script&lang=js&"
export * from "./MyDonatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports